<template>
  <div>
    <div class="grid grid-cols-2 col-gap-1 row-gap-4">
      <div class="col-span-2 grid grid-cols-2">
        <div>
          <base-label>Date</base-label>
          <el-date-picker
            @change="handleDateChange"
            v-model="date"
            type="date"
            placeholder="Pick a day"
            class="w-full"
          >
          </el-date-picker>
        </div>

        <div>
          <div v-if="displayGroupSelected" class="col-span-2">
            <base-button-primary
              class="float-right"
              @click="handleEditDisplayGroup"
              >Edit Display Group</base-button-primary
            >
          </div>
        </div>
      </div>
      <div v-if="date">
        <base-label>Album &nbsp; </base-label>
        <el-select
          v-model="albumSelected"
          @change="handleAlbumSelect"
          placeholder="Select"
          class="w-full"
        >
          <el-option
            v-for="album in albumOptions"
            :key="album.id"
            :label="album.name"
            :value="album.id"
          >
          </el-option>
        </el-select>
      </div>
      <div v-if="date">
        <base-label>Display Group</base-label>
        <el-select
          v-model="displayGroupSelected"
          @change="handleDisplayGroupChange"
          placeholder="Select"
          class="w-full"
        >
          <el-option
            v-for="displayGroup in displayGroupOptions"
            :key="displayGroup.id"
            :label="displayGroup.name"
            :value="displayGroup.id"
          >
          </el-option>
          <el-option label="Create New" value="new"></el-option>
        </el-select>
      </div>

      <div
        class="grid grid-cols-2 gap-2 p-3 bg-gray-200"
        style="height: 600px; overflow-y: scroll"
      >
        <div
          v-for="photo in album.photos"
          :key="photo.id"
          class="text-center mt-3 cursor-pointer"
        >
          <div
            class="album-image-wrapper w-full text-white pt-8"
            v-bind:class="
              inDisplayGroup(photo.id) ? 'bg-green-500' : 'bg-gray-500'
            "
          >
            <div
              @click="handleClickAlbum(photo.id)"
              class="album-image-wrapper-header mb-5 h-8"
            >
              <span v-if="!inDisplayGroup(photo.id)">
                <span v-if="displayGroup.id"> Add to display group </span>
              </span>
              <span v-else>In display group</span>
            </div>
            <el-image
              class="mx-auto"
              :src="getSource(photo)"
              :preview-src-list="[getZoomSource(photo)]"
            ></el-image>
          </div>
        </div>
      </div>
      <div
        class="grid grid-cols-2 gap-2 p-3 bg-gray-200"
        style="height: 600px; overflow-y: scroll"
      >
        <div
          v-for="photo in displayGroup.photos"
          :key="photo.id"
          class="text-center mt-3 cursor-pointer"
        >
          <div
            class="display-group-image-wrapper bg-gray-500 w-full text-white pt-8"
          >
            <div
              @click="handleClickDisplayGroup(photo.id)"
              class="display-group-image-wrapper-header mb-5 h-8"
            >
              Remove from display group
            </div>
            <el-image
              class="mx-auto"
              :src="getSource(photo)"
              :preview-src-list="[getZoomSource(photo)]"
            ></el-image>
          </div>
        </div>
      </div>
    </div>

    <base-modal
      :show="showModal"
      @close="showModal = false"
      @save="saveDisplayGroup"
    >
      <template v-slot:header> Display Group </template>
      <template v-slot:main>
        <div class="grid grid-cols-1 gap-4">
          <div class="col">
            <base-label>Name</base-label>
            <base-input v-model="modalDisplayGroup.name" />
          </div>
        </div>
      </template>
    </base-modal>
  </div>
</template>

<script>
import photo from "../../mixins/photo";
import BaseButtonPrimary from "@/components/ui/buttons/BaseButtonPrimary";

export default {
  name: "DisplayGroups",
  components: { BaseButtonPrimary },
  mixins: [photo],
  data() {
    return {
      showModal: false,
      date: null,
      albumSelected: null,
      albumOptions: [],
      displayGroupSelected: null,
      displayGroupOptions: [],
      modalDisplayGroup: {
        id: null,
        name: null,
      },
      displayGroup: {
        photos: [],
      },
      album: {
        photos: [],
      },
    };
  },
  methods: {
    inDisplayGroup(photoId) {
      return (
        this.displayGroup.photos.findIndex((photo) => photo.id === photoId) !==
        -1
      );
    },
    getSource(photo) {
      return this.getS3Photo(photo.path, photo.file_name, 250, 250, 60, false);
    },
    getZoomSource(photo) {
      return this.getS3Photo(
        photo.path,
        photo.file_name,
        1000,
        1000,
        60,
        false
      );
    },
    handleEditDisplayGroup() {
      const selectedDisplayGroup = this.displayGroupOptions.find(
        (dg) => dg.id === this.displayGroupSelected
      );
      this.modalDisplayGroup.id = selectedDisplayGroup.id;
      this.modalDisplayGroup.name = selectedDisplayGroup.name;
      this.showModal = true;
    },
    handleClickAlbum(photoId) {
      if (!this.displayGroup.id) {
        this.$notify({
          title: "Display Groups",
          message: "Please select a display group or create a new one",
          type: "warning",
        });
        return;
      }
      if (this.inDisplayGroup(photoId)) {
        this.$notify({
          title: "Display Groups",
          message: "This photo is already in this display group",
          type: "warning",
        });
        return;
      }
      this.$notify({
        title: "Display Groups",
        message: "Adding this photo to the display group",
        type: "success",
      });
      this.$store
        .dispatch("displayGroups/add_photo", {
          photoId: photoId,
          displayGroupId: this.displayGroup.id,
        })
        .then(() => {
          this.$notify({
            title: "Display Groups",
            message: "This photo has been added to the display group",
            type: "success",
          });
        });
      const index = this.album.photos.findIndex(
        (photo) => photo.id === photoId
      );
      const photo = this.album.photos[index];
      this.displayGroup.photos.push(photo);
    },
    handleClickDisplayGroup(photoId) {
      this.$notify({
        title: "Display Groups",
        message: "Removing this photo from the display group",
        type: "success",
      });
      this.$store
        .dispatch("displayGroups/remove_photo", {
          photoId: photoId,
          displayGroupId: this.displayGroup.id,
        })
        .then(() => {
          this.$notify({
            title: "Display Groups",
            message: "This photo has been removed from the display group",
            type: "success",
          });
        });
      const index = this.displayGroup.photos.findIndex(
        (photo) => photo.id === photoId
      );
      this.displayGroup.photos.splice(index, 1);
    },

    handleAlbumSelect() {
      const album = this.albumOptions.find(
        (album) => album.id === this.albumSelected
      );
      if (album) {
        this.album = album;
      }
    },

    saveDisplayGroup() {
      const data = {
        id: this.modalDisplayGroup.id,
        name: this.modalDisplayGroup.name,
        date: this.date,
        outfitter_id: this.$store.getters["auth/outfitterId"],
      };
      this.$store
        .dispatch("displayGroups/save_displayGroup", data)
        .then((resp) => {
          if (!resp.success) return;

          this.displayGroup = resp.displayGroup;
          this.displayGroupSelected = resp.displayGroup.id;
          this.getDisplayGroups();
          this.showModal = false;
          this.modalDisplayGroup = {
            id: null,
            name: null,
          };
          this.displayGroup = resp.displayGroup;
        });
    },
    handleDisplayGroupChange() {
      if (this.displayGroupSelected) {
        if (this.displayGroupSelected === "new") {
          this.displayGroupSelected = null;
          this.showModal = true;
        } else {
          const displayGroup = this.displayGroupOptions.find(
            (group) => group.id === this.displayGroupSelected
          );
          if (displayGroup) {
            this.displayGroup = displayGroup;
          }
        }
      }
    },
    handleDateChange() {
      if (!this.date) {
        this.albumOptions = [];
        return;
      }
      this.$notify({
        title: "Albums",
        message: "Loading albums",
        type: "success",
      });
      this.$store
        .dispatch("displayGroups/get_albums", {
          date: this.date,
          outfitterId: this.$store.getters["auth/outfitterId"],
        })
        .then((resp) => {
          if (!resp.success) return;

          this.albumOptions = resp.albums;
          if (!resp.albums.length) {
            this.albumSelected = null;
            this.$notify({
              title: "Albums",
              message: "No albums found for this date",
              type: "warning",
            });
            return;
          }
          this.$notify({
            title: "Albums",
            message: "Albums loaded",
            type: "success",
          });
        });
      this.getDisplayGroups();
    },
    initFromQueryParams() {
      const { date, albumId, createNew } = this.$route.query;
      if (!date || !albumId) return;

      this.date = new Date(date);
      this.$store
        .dispatch("auth/set_outfitter_id", null)
        .then((outfitterId) => {
          return this.$store.dispatch("displayGroups/get_albums", {
            date: this.date,
            outfitterId: outfitterId,
          });
        })
        .then((resp) => {
          if (!resp.success) return;

          this.albumOptions = resp.albums;
          const albumIdNum = parseInt(albumId);
          const match = resp.albums.find((a) => a.id === albumIdNum);
          if (match) {
            this.albumSelected = match.id;
            this.album = match;
          }
          this.getDisplayGroups();
          if (createNew) {
            this.showModal = true;
          }
        });
    },
    getDisplayGroups() {
      this.$notify({
        title: "Display Group",
        message: "Loading display groups",
        type: "success",
        position: "top-left",
      });
      this.$store
        .dispatch("displayGroups/get_displayGroups", {
          date: this.date,
          outfitterId: this.$store.getters["auth/outfitterId"],
        })
        .then((resp) => {
          if (!resp.success) return;

          this.displayGroupOptions = resp.displayGroups;
          if (!resp.displayGroups.length) {
            this.displayGroupSelected = null;
            this.$notify({
              title: "Display Groups",
              message: "No display groups found for this date",
              type: "warning",
              position: "top-left",
            });
            return;
          }
          this.$notify({
            title: "Display Group",
            message: "Display groups loaded",
            type: "success",
            position: "top-left",
          });
        });
    },
  },
  mounted() {
    this.initFromQueryParams();
  },
};
</script>

<style scoped>
>>> .el-image__preview {
  cursor: zoom-in;
}
</style>

